import React from 'react';
import './LegalPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">

        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p style={{ marginTop: '16px' }}>Last Updated: April 2026</p>
        </div>

        <div className="legal-notice">
          SwingSetupAI is committed to protecting your personal data in accordance with
          applicable Indian laws, including the Information Technology Act, 2000, the IT
          Rules, 2011, and the Digital Personal Data Protection Act, 2023.
        </div>

        <div className="legal-section">
          <p>
            SwingSetupAI ("we", "our", "us") operates as a technical analysis and stock
            screening platform for educational purposes. By accessing or using the platform,
            you consent to the collection and use of your personal data as described in this
            policy. For any privacy-related queries, you may contact us at{' '}
            <a href="mailto:support@swingsetupai.com" className="legal-link">
              support@swingsetupai.com
            </a>.
          </p>
        </div>

        <div className="legal-section">
          <h2>Data We Collect</h2>
          <p>
            We collect limited personal data such as your name, email address, and login
            details for account creation and communication. Payment-related information is
            processed securely through Razorpay, and we do not store your card or banking
            details on our servers. We may also collect usage data, device information, and
            IP address for improving platform performance, analytics, and ensuring security.
          </p>
        </div>

        <div className="legal-section">
          <h2>How We Use Your Data</h2>
          <p>
            Your data is used to provide and maintain the platform, process subscriptions,
            send transactional communications such as payment receipts and service updates,
            respond to support queries, improve our services, and comply with legal
            obligations. We do not sell, rent, or share your personal data with third
            parties for marketing purposes.
          </p>
        </div>

        <div className="legal-section">
          <h2>Data Storage and Retention</h2>
          <p>
            Your data is stored on secure servers, and we implement reasonable security
            practices including encryption, access controls, and monitoring systems. Data is
            retained only for as long as necessary to fulfill the purposes outlined in this
            policy or as required under applicable laws. Payment-related records may be
            retained as required under tax regulations.
          </p>
        </div>

        <div className="legal-section">
          <h2>Your Rights</h2>
          <p>
            You have the right to access, correct, or request deletion of your personal
            data, and to withdraw your consent at any time. Account deletion requests can
            be made by contacting{' '}
            <a href="mailto:support@swingsetupai.com" className="legal-link">
              support@swingsetupai.com
            </a>
            , and we typically process such requests within 30 days. Withdrawal of consent
            may affect your ability to use certain features of the platform.
          </p>
        </div>

        <div className="legal-section">
          <h2>Cookies</h2>
          <p>
            We may use cookies and similar technologies for authentication, session
            management, and analytics purposes. You can manage cookie preferences through
            your browser settings, although disabling cookies may impact platform
            functionality.
          </p>
        </div>

        <div className="legal-section">
          <h2>Third-Party Services</h2>
          <p>
            We may rely on third-party services such as Razorpay for payment processing and
            Google for authentication. These services operate under their own privacy
            policies, and we are not responsible for their practices. In certain cases, data
            may be processed using third-party tools or services that may involve
            cross-border data transfers, in compliance with applicable data protection laws.
          </p>
        </div>

        <div className="legal-section">
          <h2>Policy Updates</h2>
          <p>
            We may update this Privacy Policy from time to time. Significant changes will
            be communicated via email or platform notification. Continued use of the
            platform after such changes constitutes acceptance of the updated policy.
          </p>
        </div>


      </div>
    </div>
  );
};

export default PrivacyPolicy;
